import { Component, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { PartnerSettingsMenuLevel3Enum } from '../partner-settings-root/partner-settings-root.component';
import { AppComponent } from 'app/app.component';

@Component({
    selector: 'partner-settings-legal-documents',
    templateUrl: './partner-settings-legal-documents.component.html',
    styleUrls: ['./partner-settings-legal-documents.component.scss',
        '../../../../../styles/style-layout.scss']
})

export class PartnerSettingsLegalDocumentsComponent {
    @Input()
    public menuPermissionActive!: string;

    constructor(private messageService: MessageService, public app: AppComponent) {
        this.handleHideDocumentUpdate = this.handleHideDocumentUpdate.bind(this);
        this.handleHideDocumentStatus = this.handleHideDocumentStatus.bind(this);
    }
    @Input()
    public legalDocs: any;

    @Input()
    public activeDocumentItem: PartnerSettingsMenuLevel3Enum = PartnerSettingsMenuLevel3Enum.None;
    public documentTypeEnum = PartnerSettingsMenuLevel3Enum;

    public showUpdateDocument: boolean = false;
    public showDocumentStatus: boolean = false;

    public handleHideDocumentUpdate() {
        this.showUpdateDocument = false;
    }
    public handleShowDocumentUpdate() {
        this.showUpdateDocument = true;
    }

    public handleHideDocumentStatus() {
        this.showDocumentStatus = false;
    }
    public handleShowDocumentStatus() {
        this.showDocumentStatus = true;
    }

}
